/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbAnneeScolaireDetailDto
 */
export interface FcbAnneeScolaireDetailDto {
    /**
     * 
     * @type {number}
     * @memberof FcbAnneeScolaireDetailDto
     */
    anneeDebut?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbAnneeScolaireDetailDto
     */
    anneeFin?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbAnneeScolaireDetailDto
     */
    idanneeScolaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAnneeScolaireDetailDto
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbAnneeScolaireDetailDto
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbAnneeScolaireDetailDto
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbAnneeScolaireDetailDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbAnneeScolaireDetailDto interface.
 */
export function instanceOfFcbAnneeScolaireDetailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAnneeScolaireDetailDtoFromJSON(json: any): FcbAnneeScolaireDetailDto {
    return FcbAnneeScolaireDetailDtoFromJSONTyped(json, false);
}

export function FcbAnneeScolaireDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAnneeScolaireDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeDebut': !exists(json, 'anneeDebut') ? undefined : json['anneeDebut'],
        'anneeFin': !exists(json, 'anneeFin') ? undefined : json['anneeFin'],
        'idanneeScolaire': !exists(json, 'idanneeScolaire') ? undefined : json['idanneeScolaire'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : (json['dateDebut'] === null ? null : new Date(json['dateDebut'])),
        'dateFin': !exists(json, 'dateFin') ? undefined : (json['dateFin'] === null ? null : new Date(json['dateFin'])),
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbAnneeScolaireDetailDtoToJSON(value?: FcbAnneeScolaireDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeDebut': value.anneeDebut,
        'anneeFin': value.anneeFin,
        'idanneeScolaire': value.idanneeScolaire,
        'description': value.description,
        'dateDebut': value.dateDebut === undefined ? undefined : (value.dateDebut === null ? null : value.dateDebut.toISOString()),
        'dateFin': value.dateFin === undefined ? undefined : (value.dateFin === null ? null : value.dateFin.toISOString()),
        'actif': value.actif,
    };
}

